/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from 'react';
import { MountInstructions, mountView } from 'redux/actions/global';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch } from 'hooks/typed_hooks';

function ViewMounterComponent(props: any) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const params = useParams();

  const mountViewDispatcher = () => {
    if (props.mountInstructions.overrideLocation) {
      history.push(props.mountInstructions.overrideLocation);
    }

    if (Array.isArray(props.mountInstructions)) {
      props.mountInstructions.forEach((view) => {
        view.params = { ...params };
        dispatch(mountView(view));
      });
    } else {
      props.mountInstructions.params = { ...params };
      dispatch(mountView(props.mountInstructions));
    }
  };

  useEffect(() => {
    mountViewDispatcher();
  }, Object.entries(params).map((x) => x[1]));

  useEffect(() => {
    if (!props.location.fromNavigation) {
      mountViewDispatcher();
    }
  }, []);

  useEffect(() => {
    if (props.location.fromNavigation) {
      history.replace({ ...props.location, fromNavigation: false });
      mountViewDispatcher();
    }
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export const ViewMounter = (props, mountInstructions: MountInstructions | MountInstructions[]) => (
  <ViewMounterComponent
    {...props}
    mountInstructions={mountInstructions}
  />
);
